import styled from 'styled-components';

const Logo = styled.img`
    max-height: 1.875rem;
    width: auto;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

export default Logo;
